// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: '#4484ce, #1ad7c0, #ff9b11, #9b59b6, #ff7f7f, #ecf0f1',
  firstName: 'Anuj',
  middleName: '',
  lastName: 'Dhingra',
  message: ' Passionate about changing the world with technology. ',
  icons: [
    {
      image: 'fa-github',
      url: 'https://github.com/Anuj0103',
    },
    {
      image: 'fa-linkedin',
      url: 'https://www.linkedin.com/in/anuj-dhingra-4b4a80192/',
    },
    {
      image: 'fa-twitter',
      url: 'https://twitter.com/AnujDhingra7',
    },
  ],
};

// ABOUT SECTION
// If you want the About Section to show a profile picture you can fill the profilePictureLink either with:
//a) your Instagram username
//      i.e:profilePictureLink:"johnDoe123",
//b) a link to an hosted image
//      i.e:profilePictureLink:"www.picturesonline.com/johnDoeFancyAvatar.jpg",
//c) image in "editable-stuff" directory and use require("") to import here,
//      i.e: profilePictureLink: require("../editable-stuff/hashirshoaeb.png"),
//d) If you do not want any picture to be displayed, just leave it empty :)
//      i.e: profilePictureLink: "",
// For Resume either provide link to your resume or import from "editable-stuff" directory
//     i.e resume: require("../editable-stuff/resume.pdf"),
//         resume: "https://docs.google.com/document/d/13_PWdhThMr6roxb-UFiJj4YAFOj8e_bv3Vx9UHQdyBQ/edit?usp=sharing",

const about = {
  show: true,
  heading: 'About Me',
  imageLink: require('../editable-stuff/img.jpg'),
  imageSize: 375,
  message:
    'My name is Anuj Dhingra, and I am currently a fourth-year student pursuing a degree in Computer Science Engineering at Maharaja Agrasen Institute of Technology. Throughout my academic journey, I have developed a deep passion for giving back to the community, and my goal is to integrate this passion into my engineering career.Through my personal portfolio, I aim to showcase my journey as a student, engineer, and contributor to the open source community. I invite you to explore my projects, experiences, and the impact I have made. Together, we can explore ways to make a positive difference in the world through engineering and community-focused initiatives.',
  resume:
    'https://drive.google.com/file/d/1FexAFHsokPk2PkWAvTr7SywRArLZrbgk/view?usp=share_link',
};

// PROJECTS SECTION
// Setting up project lenght will automatically fetch your that number of recently updated projects, or you can set this field 0 to show none.
//      i.e: reposLength: 0,
// If you want to display specfic projects, add the repository names,
//      i.e ["repository-1", "repo-2"]
const repos = {
  show: true,
  heading: 'Recent Projects',
  gitHubUsername: 'Anuj0103', //i.e."johnDoe12Gh"
  reposLength: 0,
  specificRepos: [
    'election_vote_dapp',
    'AI-NFT-GENERATOR-APP',
    'todoListDapp',
    // 'Covicure_website',
    'project_cryptoverse',
    'P2-facerecognitionbrain',
    'P4-Tours-Project-React',
    'P5-Reviews-React',
    'P6-MenuDisplay-React',
    'Background-Generator',
    'P7-GroceryList-React',
    'P8-Navbar-React',
  ],
};

// Leadership SECTION
const leadership = {
  show: false,
  heading: 'Leadership',
  message:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae auctor eu augue ut lectus arcu bibendum at varius. Libero justo laoreet sit amet cursus sit amet. Imperdiet dui accumsan sit amet nulla facilisi morbi. At auctor urna nunc id. Iaculis urna id volutpat lacus laoreet non curabitur gravida. Et magnis dis parturient montes nascetur ridiculus mus mauris. In nisl nisi scelerisque eu ultrices vitae auctor. Mattis nunc sed blandit libero volutpat sed cras ornare. Pulvinar neque laoreet suspendisse interdum consectetur libero.',
  images: [
    {
      img: require('../editable-stuff/img.jpg'),
      label: 'First slide label',
      paragraph: 'Nulla vitae elit libero, a pharetra augue mollis interdum.',
    },
    {
      img: require('../editable-stuff/img.jpg'),
      label: 'Second slide label',
      paragraph: 'Nulla vitae elit libero, a pharetra augue mollis interdum.',
    },
  ],
  imageSize: {
    width: '615',
    height: '450',
  },
};

// SKILLS SECTION
const skills = {
  show: true,
  heading: 'Skills',
  hardSkills: [
    { name: 'C/C++', value: 95 },
    { name: 'PostGreSQL', value: 75 },
    { name: 'Data Structures', value: 85 },
    { name: 'NodeJs/ExpressJs', value: 80 },
    { name: 'JavaScript', value: 90 },
    { name: 'React/React Hooks', value: 90 },
    { name: 'DataBase Management', value: 70 },
    { name: 'Authentication and Authorization', value: 70 },
    { name: 'Semantic UI', value: 80 },
    { name: 'HTML/CSS', value: 95 },
    { name: 'Python', value: 50 },
    { name: 'Solidity', value: 50 },
    { name: 'OOPS', value: 90 },
  ],
  softSkills: [
    { name: 'Goal-Oriented', value: 80 },
    { name: 'Collaboration', value: 90 },
    { name: 'Positivity', value: 75 },
    { name: 'Adaptability', value: 85 },
    { name: 'Problem Solving', value: 75 },
    { name: 'Empathy', value: 90 },
    { name: 'Organization', value: 70 },
    { name: 'Creativity', value: 90 },
  ],
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: 'Get In Touch',
  message:
    "I'm currently looking for summer internship opportunities! If you know of any positions available, if you have any questions, or if you just want to say hi, please feel free to email me at",
  email: 'anujdhingra01@gmail.com',
};

// const experiences = {
//   show: false,
//   heading: "Experiences",
//   data: [
//     {
//       role: 'Software Engineer',// Here Add Company Name
//       companylogo: require('../assets/img/dell.png'),
//       date: 'June 2018 – Present',
//     },
//     {
//       role: 'Front-End Developer',
//       companylogo: require('../assets/img/boeing.png'),
//       date: 'May 2017 – May 2018',
//     },
//   ]
// }

// Blog SECTION
// const blog = {
//   show: false,
// };

export { navBar, mainBody, about, repos, skills, leadership, getInTouch };
